// src/theme/components/box.js
// Box component için mobil optimize variants

const Box = {
  variants: {
    section: {
      // Section container için mobil optimize padding
      p: { base: 4, md: 6, lg: 8 },  // 16px, 24px, 32px
      my: { base: 4, md: 6, lg: 8 },
    },
    card: {
      // Card içeriği için mobil optimize padding
      p: { base: 3, md: 4, lg: 5 },  // 12px, 16px, 20px
      borderRadius: 'lg',
      bg: 'bgCard',
      borderWidth: '1px',
      borderColor: 'borderPrimary',
      backdropFilter: 'saturate(180%) blur(22px)',
      WebkitBackdropFilter: 'saturate(180%) blur(22px)',
    },
    compact: {
      // Kompakt içerik için
      p: { base: 2, md: 3 },  // 8px, 12px
      m: { base: 2, md: 3 },
    },
    comfortable: {
      // Rahat içerik için
      p: { base: 4, md: 5, lg: 6 },  // 16px, 20px, 24px
      m: { base: 3, md: 4, lg: 5 },
    },
  },
};

export default Box;
